import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const PAGE_BASE_URL =
  `${API_BASE_URL}/pages`;

// ==========================
// GET PAGE BY SLUG
// ==========================
export const getPageBySlugApi = async (
  slug: string
) => {
  try {
    const res = await axios.get(
      `${PAGE_BASE_URL}/slug/${encodeURIComponent(slug)}`
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      page: null,
      data: null,
      message:
        error?.response?.data?.message ||
        "Failed to load page",
    };
  }
};
